<template>
    <div class="footerWrapper">
        <div class="container">
            <!-- <span class="shape one"></span>
            <span class="shape two"></span>
            <span class="shape three"></span> -->
            <div class="dots">
                <span class="dots__dot e-small" style="--dotbg: #ffffff"></span>
                <span class="dots__dot purple"></span>
                <span class="dots__dot white-small"></span>
            </div>
            <!-- on desktop -->
            <footer class="footer hide-on-lg">
                <div class="footer__detail">
                    <div class="footer__detail--logo">
                        <router-link to="/"
                            ><img
                                :src="footerInfo.logo.icon"
                                class="img-fluid"
                                alt="Buytech Logo"
                        /></router-link>
                    </div>
                    <p>
                        {{ footerInfo.text }}
                    </p>
                    <ul class="footer__detail--socialIcons">
                        <li
                            v-for="media in footerInfo.social_links"
                            :key="media.id"
                        >
                            <a :href="media.url" target="_blank">
                                <img
                                    :src="media.image"
                                    :alt="'buytech-' + media.name"
                                    class="img-fluid"
                                />
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="footer__links">
                    <div class="footerTitle">
                        {{ $t('general.Important links') }}
                    </div>
                    <ul>
                        <li
                            v-for="link in footerInfo.important_links"
                            :key="link.id"
                        >
                            <a :href="link.url" target="_blank">
                                {{ link.name }}
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="footer__contact">
                    <div class="footerTitle">
                        {{ $t('general.Contact info') }}
                    </div>
                    <ul>
                        <li>
                            <img
                                src="/assets/images/svg/location.svg"
                                alt=""
                                class="img-fluid"
                            />
                            {{ footerInfo.contact_us.location }}
                        </li>
                        <li>
                            <img
                                src="/assets/images/svg/phone.svg"
                                alt=""
                                class="img-fluid"
                            />
                            {{ footerInfo.contact_us.contact }}
                        </li>
                        <li>
                            <img
                                src="/assets/images/svg/mail.svg"
                                alt=""
                                class="img-fluid"
                            />
                            {{ footerInfo.contact_us.email }}
                        </li>
                    </ul>
                </div>
            </footer>
            <div class="copyRight hide-on-lg">
                {{ footerInfo.copyright }}
            </div>
            <!-- on responsive -->
            <footer class="footer show-on-lg d-none">
                <div class="footer__logo">
                    <router-link to="/"
                        ><img
                            :src="footerInfo.logo.icon"
                            class="img-fluid"
                            alt="Buytech Logo"
                    /></router-link>
                </div>
                <p>
                    {{ footerInfo.text }}
                </p>
                <div class="footer__links">
                    <ul>
                        <li
                            v-for="link in footerInfo.important_links"
                            :key="link.id"
                        >
                            <a :href="link.url" target="_blank">
                                {{ link.name }}
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="footer__contact">
                    <ul>
                        <li>
                            <img
                                src="/assets/images/svg/mail.svg"
                                alt=""
                                class="img-fluid"
                            />{{ footerInfo.contact_us.email }}
                        </li>
                        <li>
                            <img
                                src="/assets/images/svg/location.svg"
                                alt=""
                                class="img-fluid"
                            />
                            {{ footerInfo.contact_us.location }}
                        </li>
                        <li>
                            <img
                                src="/assets/images/svg/phone.svg"
                                alt=""
                                class="img-fluid"
                            />{{ footerInfo.contact_us.contact }}
                        </li>
                    </ul>
                </div>
                <ul class="footer__socialIcons">
                    <li
                        v-for="media in footerInfo.social_links"
                        :key="media.id"
                    >
                        <a :href="media.url" target="_blank">
                            <img
                                :src="media.image"
                                :alt="'buytech-' + media.name"
                                class="img-fluid"
                            />
                        </a>
                    </li>
                </ul>
                <div class="copyRight">
                    {{ footerInfo.copyright }}
                </div>
            </footer>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Footer',
    data: () => {
        return {}
    },
    props: {
        footerInfo: Object,
    },
}
</script>
<style lang="scss" scoped>
[lang='ar'] {
    .footerWrapper {
        .footer__links ul li {
            padding-left: unset !important;
            padding-right: 28px !important;
        }
        .footer__detail--socialIcons li {
            margin-right: 20px !important;
        }
        .footer__links ul li:before {
            left: unset !important;
            right: 0 !important;
        }
        .footer__contact ul li img {
            margin-left: 1.625rem !important;
            margin-right: unset !important;
        }
    }
}
</style>
